import React from 'react';
import { motion } from 'framer-motion';
import ReactTooltip from 'react-tooltip';
import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor } from '../../client';
import { experiences, skillIcons, skills } from '../../data/portfolioContent';
import './Skills.scss';

const Skills = () => (
  <>
    <h2 className="head-text">Skills & Experience</h2>

    <div className="app__skills-container">
      <motion.div className="app__skills-list">
        {skills.map((skill) => {
          const skillIcon = skillIcons[skill];

          return (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill}
            >
              <div className="app__flex" style={{ backgroundColor: '#141414' }}>
                {skillIcon ? (
                  <img src={urlFor(skillIcon).width(72).height(72).fit('max').url()} alt={skill} loading="lazy" />
                ) : (
                  <span>{skill.slice(0, 2)}</span>
                )}
              </div>
              <p className="p-text">{skill}</p>
            </motion.div>
          );
        })}
      </motion.div>

      <div className="app__skills-exp">
        {experiences.map((experience) => (
          <motion.div className="app__skills-exp-item" key={experience.year}>
            <div className="app__skills-exp-year">
              <p className="bold-text">{experience.year}</p>
            </div>
            <motion.div className="app__skills-exp-works">
              {experience.works.map((work) => (
                <React.Fragment key={`${experience.year}-${work.name}`}>
                  <motion.div
                    whileInView={{ opacity: [0, 1] }}
                    transition={{ duration: 0.5 }}
                    className="app__skills-exp-work"
                    data-tip
                    data-for={work.name}
                  >
                    <h4 className="bold-text">{work.name}</h4>
                    <p className="p-text">{work.company}</p>
                  </motion.div>
                  <ReactTooltip
                    id={work.name}
                    effect="solid"
                    arrowColor="#fff"
                    className="skills-tooltip"
                  >
                    {work.desc}
                  </ReactTooltip>
                </React.Fragment>
              ))}
            </motion.div>
          </motion.div>
        ))}
      </div>
    </div>
  </>
);

export default AppWrap(
  MotionWrap(Skills, 'app__skills'),
  'skills',
  'app__whitebg',
);
